import type { ReactNode } from "react";

import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { FrameEventTypes, useEventPublish } from "../events";
import type { ImportNodeTarget, NodeSelectionCriteria } from "../library/index.ts";
import { AddThumbnailItemButton } from "./AddThumbnailItemButton";

type Props = {
  disabled?: boolean;
  navGroupId: number;
  browseTarget: ImportNodeTarget;
  templateCriteria: NodeSelectionCriteria;
  tooltip?: ReactNode;
};

export const AddFrameButton = ({ disabled, navGroupId, browseTarget, templateCriteria, tooltip }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  const publish = useEventPublish();

  const handleCreateYourOwn = () => publish(FrameEventTypes.ADD_FRAME_REQUESTED, { navGroupId });

  return (
    <AddThumbnailItemButton
      disabled={disabled}
      tooltip={tooltip ?? formatMessage("addFrame")}
      browseLabel={formatMessage("browseFrameTemplates")}
      pasteLabel={formatMessage("pasteFrame")}
      browseTarget={browseTarget}
      templateCriteria={templateCriteria}
      onCreateYourOwn={handleCreateYourOwn}
      data-test="add-frame-button"
    />
  );
};

const formatStrings = {
  addFrame: {
    en: "Add Frame",
  },
  browseFrameTemplates: {
    en: "Browse Frame Templates",
  },
  pasteFrame: {
    en: "Paste Frame",
  },
} satisfies FormatMessages;
